<template>
  <div class="notice_popup_wrap" v-if="isVisible">
    <div class="notice_popup_bg" @click="closePopup"></div>
    <div class="notice_popup_container">
      <div class="notice_popup_content">
        <div class="notice_popup_header">
          <button type="button" class="notice_close_btn" @click="closePopup">
            <span>×</span>
          </button>
        </div>
        <div class="notice_popup_body">
          <slot></slot>
          <button type="button" class="notice_confirm_btn" @click="openLink" v-if="linkUrl">
            {{ buttonText }}
          </button>
        </div>
        <div class="notice_popup_footer">
          <label class="notice_checkbox_label">
            <input type="checkbox" v-model="dontShowToday" />
            <span>오늘 하루 다시 열지 않기</span>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueCookies from 'vue-cookies'

export default {
  name: 'NoticeLayerPopup',
  props: {
    linkUrl: {
      type: String,
      default: ''
    },
    buttonText: {
      type: String,
      default: '개인정보 이전 동의안 전문 확인'
    }
  },
  data () {
    return {
      isVisible: false,
      dontShowToday: false
    }
  },
  mounted () {
    this.checkAndShowPopup()
  },
  methods: {
    checkAndShowPopup () {
      const hideUntil = VueCookies.get('hideNoticePopup')
      if (!hideUntil) {
        this.isVisible = true
      } else {
        const hideDate = new Date(hideUntil)
        const now = new Date()
        if (now > hideDate) {
          this.isVisible = true
          VueCookies.remove('hideNoticePopup')
        }
      }
    },
    closePopup () {
      if (this.dontShowToday) {
        const tomorrow = new Date()
        tomorrow.setHours(24, 0, 0, 0)
        VueCookies.set('hideNoticePopup', tomorrow.toISOString(), { expires: '1d' })
      }
      this.isVisible = false
    },
    openLink () {
      if (this.linkUrl) {
        window.open(this.linkUrl, '_blank')
      }
    }
  }
}
</script>

<style scoped>
.notice_popup_wrap {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
}

.notice_popup_bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.notice_popup_container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  width: 90%;
  max-width: 600px;
  max-height: 85vh;
  overflow: hidden;
  z-index: 10000;
  display: flex;
  flex-direction: column;
}

.notice_popup_content {
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  min-height: 0;
}

.notice_popup_header {
  position: relative;
  padding: 15px 20px;
  border-bottom: 1px solid #e0e0e0;
}

.notice_close_btn {
  position: absolute;
  top: 10px;
  right: 15px;
  background: none;
  border: none;
  font-size: 32px;
  line-height: 1;
  color: #666;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.notice_close_btn:hover {
  color: #000;
}

.notice_popup_body {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
  min-height: 0;
}

.notice_popup_footer {
  padding: 15px 20px;
  border-top: 1px solid #e0e0e0;
  background-color: #f9f9f9;
}

.notice_checkbox_label {
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
}

.notice_checkbox_label input[type="checkbox"] {
  margin-right: 8px;
  cursor: pointer;
}

.notice_checkbox_label span {
  font-size: 14px;
  color: #333;
}

.notice_confirm_btn {
  width: 100%;
  padding: 15px 20px;
  background-color: #001f5c;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  margin-top: 20px;
}

.notice_confirm_btn:hover {
  background-color: #002a7a;
}
</style>
